var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00033 9.33335V10.6667C6.93946 10.6667 5.92204 11.0881 5.1719 11.8383C4.42175 12.5884 4.00033 13.6058 4.00033 14.6667H2.66699C2.66699 13.2522 3.2289 11.8956 4.22909 10.8955C5.22928 9.89526 6.58584 9.33335 8.00033 9.33335ZM8.00033 8.66669C5.79033 8.66669 4.00033 6.87669 4.00033 4.66669C4.00033 2.45669 5.79033 0.666687 8.00033 0.666687C10.2103 0.666687 12.0003 2.45669 12.0003 4.66669C12.0003 6.87669 10.2103 8.66669 8.00033 8.66669ZM8.00033 7.33335C9.47366 7.33335 10.667 6.14002 10.667 4.66669C10.667 3.19335 9.47366 2.00002 8.00033 2.00002C6.52699 2.00002 5.33366 3.19335 5.33366 4.66669C5.33366 6.14002 6.52699 7.33335 8.00033 7.33335ZM12.0003 14.3334L10.041 15.3634L10.415 13.182L8.83033 11.6367L11.021 11.318L12.0003 9.33335L12.9803 11.318L15.1703 11.6367L13.5857 13.182L13.959 15.3634L12.0003 14.3334Z",
    fill: "#D9BC92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSet);
export default __webpack_public_path__ + "static/media/set.9d6300c1f0d7571fefdd27ca4f904b39.svg";
export { ForwardRef as ReactComponent };